<template>
  <div>
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="4" :sm="24">
            <a-form-item label="名称">
              <a-input v-model="queryParam.name" placeholder="名称" allow-clear/>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="24" v-if="false">
            <a-form-item label="英文名称">
              <a-input v-model="queryParam.en_name" placeholder="英文名称" allow-clear/>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="24">
            <a-form-item label="税号">
              <a-input v-model="queryParam.unique_code" placeholder="税号" allow-clear/>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="24">
            <a-form-item label="法人">
              <a-input v-model="queryParam.legal_representative" placeholder="法人" allow-clear/>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="24" v-if="false">
            <a-form-item label="国家">
              <a-input v-model="queryParam.country" placeholder="国家" allow-clear/>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="24">
            <a-form-item label="联系人">
              <a-input v-model="queryParam.contact" placeholder="联系人" allow-clear/>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="24" v-if="false">
            <a-form-item label="电话">
              <a-input v-model="queryParam.phone" placeholder="电话" allow-clear/>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="24" v-if="false">
            <a-form-item label="邮箱">
              <a-input v-model="queryParam.mail" placeholder="邮箱" allow-clear/>
            </a-form-item>
          </a-col>
          <a-col :md="2" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
            </span>
          </a-col>
          <a-col :md="2" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleAdd">新建</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <s-table
      ref="table"
      size="small"
      rowKey="id"
      :loading="loading"
      :columns="columns"
      :data="loadData"
      :scroll="{ x: 1500 }"
    >
      <span slot="serial" slot-scope="text, record, index">
        {{ index + 1 }}
      </span>
      <div slot="money_render" slot-scope="text" style="text-align: right;">
        <span v-if="text">{{ text | numberFormat }}</span>
      </div>
      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="handleClientMaterial(record)">资料</a>
          <a-divider type="vertical" />
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-popconfirm
            title="确定要删除么？"
            ok-text="确定"
            cancel-text="取消"
            @confirm="handleDelet(record)"
          >
            <a>删除</a>
          </a-popconfirm>
        </template>
      </span>
    </s-table>
    <create-form
      ref="createModal"
      :visible="visible"
      :loading="confirmLoading"
      :model="mdl"
      @cancel="handleAddCancel"
      @ok="handleOk"
    />
  </div>
</template>

<script>
import moment from 'moment'
import { STable } from '@/components'
import { client_list, client_create, client_delete } from '@/api/trade_client'
import { Dictionaries } from '@/common/AllConstant'
import CreateForm from '../modules/CreateForm'

export default {
  name: 'TableList',
  components: {
    STable,
    CreateForm
  },
  data () {
    return {
      loading: false,
      confirmLoading: false,
      dictionaries: Dictionaries,
      // 创建窗口控制
      visible: false,
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '序号',
          width: 50,
          fixed: 'left',
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '名称',
          dataIndex: 'name',
          width: 200,
          fixed: 'left',
          ellipsis: true
        },
        {
          title: '类型',
          dataIndex: 'types',
          width: 150,
          ellipsis: true,
          customRender: (types) => types.map(t => this.$Dictionaries.trade_client_types[t])
            .join(',')
        },
        {
          title: '国家/地区',
          dataIndex: 'country',
          width: 150,
          ellipsis: true,
          customRender: (text) => this.$Dictionaries.country[text] || ''
        },
        {
          title: '英文名称',
          dataIndex: 'en_name',
          width: 180,
          ellipsis: true
        },
        {
          title: '税号',
          dataIndex: 'unique_code',
          width: 200,
          ellipsis: true
        },
        {
          title: '营业执照号',
          width: 160,
          ellipsis: true,
          dataIndex: 'business_license_number'
        },
        {
          title: '统一社会信用代码',
          width: 160,
          ellipsis: true,
          dataIndex: 'unified_social_credit_code'
        },
        {
          title: '注册地址',
          width: 160,
          ellipsis: true,
          dataIndex: 'registered_address'
        },
        {
          title: '注册资本',
          width: 160,
          ellipsis: true,
          dataIndex: 'registered_capital',
          align: 'right',
          scopedSlots: { customRender: 'money_render' }
        },
        {
          title: '法人',
          dataIndex: 'legal_representative',
          width: 150,
          align: 'center',
          ellipsis: true
        },
        {
          title: '联系人',
          width: 160,
          ellipsis: true,
          dataIndex: 'contact'
        },
        {
          title: '电话',
          ellipsis: true,
          width: 160,
          dataIndex: 'phone'
        },
        {
          title: '邮箱',
          ellipsis: true,
          width: 180,
          dataIndex: 'mail'
        },
        {
          title: '传真',
          ellipsis: true,
          width: 120,
          dataIndex: 'fax'
        },
        {
          title: '金蝶编码',
          ellipsis: true,
          width: 120,
          dataIndex: 'jd_code'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '160px',
          fixed: 'right',
          align: 'center',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return client_list(Object.assign(parameter, this.queryParam))
          .then(res => {
            return res.data
          })
      },
      selectedRowKeys: [],
      selectedRows: [],

      // custom table alert & rowSelection
      options: {
        alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
        rowSelection: {
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange
        }
      },
      optionAlertShow: false
    }
  },
  created () {
    this.tableOption()
  },
  methods: {
    tableOption () {
      if (!this.optionAlertShow) {
        this.options = {
          alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    handleAdd () {
      const date = new Date()
      this.mdl = { code: date.getFullYear() + '' + (date.getMonth() + 1) + date.getDay() }
      this.visible = true
    },
    handleAddCancel () {
      this.visible = false

      const form = this.$refs.createModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleEdit (record) {
      // this.$emit('onEdit', record)
      this.$router.push({ path: '/trade/client/' + record.id })
    },
    handleClientMaterial (record) {
      // this.$emit('onEdit', record)
      this.$router.push({ path: '/trade/client/' + record.id + '/material', query: { record: record.name } })
    },
    handleDelet (record) {
      client_delete(record.id).then((res) => {
        if (res.code === 1000) {
          this.$refs.table.refresh()
        }
      })
    },
    handleOk () {
      const form = this.$refs.createModal.form
      form.validateFields((errors, values) => {
        if (!errors) {
          console.log('values', values)
            // 新增
          this.confirmLoading = true
          client_create(values).then(res => {
              if (res.code === 1000) {
                this.visible = false
                // 重置表单数据
                form.resetFields()
                // 刷新表格
                this.$refs.table.refresh()
              }
          }).finally(() => {
            this.confirmLoading = false
          })
        }
      })
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },

    resetSearchForm () {
      this.queryParam = {
        date: moment(new Date())
      }
    }
  }
}
</script>
